export default "__VITE_ASSET__BHRRCvFb__"